import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "filterLine"
};
const _hoisted_2 = {
  class: "filterFieldsFullWidth"
};
const _hoisted_3 = {
  class: "filterItem"
};
const _hoisted_4 = {
  class: "titleFilter"
};
const _hoisted_5 = {
  class: "filterItem"
};
const _hoisted_6 = {
  class: "titleFilter"
};
const _hoisted_7 = {
  class: "filterItem"
};
const _hoisted_8 = {
  class: "titleFilter"
};
const _hoisted_9 = {
  class: "filterExpand"
};
const _hoisted_10 = {
  class: "filterLine"
};
const _hoisted_11 = {
  class: "filterFieldsFullWidth"
};
const _hoisted_12 = {
  class: "filterItem"
};
const _hoisted_13 = {
  class: "titleFilter"
};
const _hoisted_14 = {
  class: "filterItem"
};
const _hoisted_15 = {
  class: "titleFilter"
};
const _hoisted_16 = {
  class: "filtersRecap"
};
const _hoisted_17 = {
  class: "filterTags"
};
const _hoisted_18 = {
  class: "labelNumberSpeaches"
};
const _hoisted_19 = {
  class: "tableHeader"
};
const _hoisted_20 = {
  class: "speachPictoLine"
};
const _hoisted_21 = {
  class: "tableHeader"
};
const _hoisted_22 = {
  class: "tableHeader"
};
const _hoisted_23 = {
  class: "columnDate"
};
const _hoisted_24 = {
  class: "tableHeader"
};
const _hoisted_25 = {
  class: "actionColumn"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  class: "clickableIconContainer"
};
const _hoisted_28 = {
  class: "clickableIconInfo"
};
const _hoisted_29 = {
  key: 1,
  class: "clickableCell"
};
const _hoisted_30 = {
  key: 2,
  class: "clickableCell"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  key: 0,
  class: "loadingContainer"
};
const _hoisted_34 = {
  class: "loadingContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_input = _resolveComponent("w-input");
  const _component_w_select_advanced = _resolveComponent("w-select-advanced");
  const _component_w_date_picker_range = _resolveComponent("w-date-picker-range");
  const _component_el_affix = _resolveComponent("el-affix");
  const _component_w_tag = _resolveComponent("w-tag");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_speach_cell = _resolveComponent("speach-cell");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_user_cell = _resolveComponent("user-cell");
  const _component_w_date = _resolveComponent("w-date");
  const _component_loader = _resolveComponent("loader");
  const _component_el_table = _resolveComponent("el-table");
  const _component_infinite_loading = _resolveComponent("infinite-loading");
  const _component_manage_periodic_reviewers = _resolveComponent("manage-periodic-reviewers");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tableLayout", {
      loaded: _ctx.isLoaded
    }])
  }, [_createVNode(_component_el_affix, {
    offset: 80,
    onChange: _ctx.onFixChange
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["filterBar", _ctx.fixeBar ? 'fix' : ''])
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.speachTitle')), 1), _createVNode(_component_w_input, {
      modelValue: _ctx.filterByTitle,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.filterByTitle = $event),
      placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.speachTitle'),
      clearable: "",
      onInput: _cache[1] || (_cache[1] = $event => _ctx.debouncedSearch()),
      "data-test": "speach-management-search-title"
    }, {
      prefix: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify",
        class: "iconMagnify"
      })]),
      _: 1
    }, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.author')), 1), _createVNode(_component_w_input, {
      modelValue: _ctx.filterByAuthor,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.filterByAuthor = $event),
      placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.author'),
      clearable: "",
      onInput: _cache[3] || (_cache[3] = $event => _ctx.debouncedSearch())
    }, {
      prefix: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify",
        class: "iconMagnify"
      })]),
      _: 1
    }, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.state')), 1), _createVNode(_component_w_select_advanced, {
      "value-key": "id",
      options: _ctx.availableActions,
      placeholder: _ctx.$t('admin.dashboard.speaches.search.title.state'),
      onChange: _ctx.changeSelectedAction,
      value: _ctx.filterByAction,
      "collapse-tags": true,
      "label-key": "name",
      "data-test": "speach-action-selection"
    }, null, 8, ["options", "placeholder", "onChange", "value"])])]), _createElementVNode("div", _hoisted_9, [_cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "titleFilter"
    }, " ", -1)), !_ctx.filterIsExpanded ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      icon: "filter-variant-plus",
      class: "iconExpand",
      onClick: _cache[4] || (_cache[4] = $event => _ctx.filterIsExpanded = !_ctx.filterIsExpanded)
    })) : (_openBlock(), _createBlock(_component_icon, {
      key: 1,
      icon: "filter-variant-minus",
      class: "iconExpand",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.filterIsExpanded = !_ctx.filterIsExpanded)
    }))])]), _createVNode(_Transition, {
      name: "expand"
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.date')), 1), _createVNode(_component_w_date_picker_range, {
        "calendar-range": _ctx.calendarRange,
        onChangeCalendarRange: _ctx.changeCalendarRange,
        separator: "-",
        placement: "bottom-end"
      }, null, 8, ["calendar-range", "onChangeCalendarRange"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('admin.dashboard.speaches.periodicReview.filters.nextReviewDate.title')), 1), _createVNode(_component_w_date_picker_range, {
        "calendar-range": _ctx.calendarRangeReview,
        onChangeCalendarRange: _ctx.changeCalendarRangeReview,
        separator: "-",
        placement: "bottom-end"
      }, null, 8, ["calendar-range", "onChangeCalendarRange"])])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "filterExpand"
      }, null, -1))], 512), [[_vShow, _ctx.filterIsExpanded]])]),
      _: 1
    })], 2)]),
    _: 1
  }, 8, ["onChange"]), _withDirectives(_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_ctx.filterByTitle ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 0,
    "text-tag": _ctx.filterByTitle,
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByTitle
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true), _ctx.filterByAuthor ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 1,
    "text-tag": _ctx.filterByAuthor,
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByAuthor
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true), _ctx.filterByAction ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 2,
    "text-tag": _ctx.filterByAction,
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByAction
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true), _ctx.calendarRange && _ctx.calendarRange[0] ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 3,
    "text-tag": _ctx.$t('admin.dashboard.speaches.filterChip.date', {
      start: _ctx.$d(_ctx.calendarRange[0]),
      end: _ctx.$d(_ctx.calendarRange[1])
    }),
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByCalendarRange
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true), _ctx.calendarRangeReview && _ctx.calendarRangeReview[0] ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 4,
    "text-tag": _ctx.$t('admin.dashboard.speaches.periodicReview.filters.nextReviewDate.chipLabel', {
      start: _ctx.$d(_ctx.calendarRangeReview[0]),
      end: _ctx.$d(_ctx.calendarRangeReview[1])
    }),
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByCalendarRangeReview
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "labelClearFilters",
    onClick: _cache[6] || (_cache[6] =
    //@ts-ignore
    (...args) => _ctx.clearAllFilters && _ctx.clearAllFilters(...args))
  }, _toDisplayString(_ctx.$t('admin.dashboard.users.clearFilters')), 1)], 512), [[_vShow, _ctx.filterByTitle !== '' || _ctx.filterByAuthor !== '' || _ctx.filterByAction !== null || _ctx.calendarRange && _ctx.calendarRange.length > 0 && _ctx.calendarRange[0] || _ctx.calendarRangeReview && _ctx.calendarRangeReview.length > 0 && _ctx.calendarRangeReview[0]]]), _createElementVNode("div", _hoisted_18, _toDisplayString(
  // noinspection TypeScriptValidateTypes: We can totally add parameters to the $t method, for parameterized translations (and it works)
  _ctx.$t('admin.dashboard.speaches.nbSpeaches', {
    total: _ctx.totalSpeaches
  })), 1), _createElementVNode("div", {
    id: "TableSpeaches",
    class: _normalizeClass(!_ctx.infiniteLoadingEnd ? 'tableSpeachesPadding' : '')
  }, [_ctx.listSpeaches.length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    class: "tableCustom",
    "table-layout": "auto",
    ref: "tableRef",
    "show-overflow-tooltip": true,
    data: _ctx.listSpeaches,
    "tooltip-effect": "light",
    "row-class-name": "speachManagementClickableRow"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      width: "500"
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.speachTitle')), 1)]),
      default: _withCtx(speach => [_createVNode(_component_speach_cell, {
        speach: speach.row,
        "search-term": _ctx.filterByTitle,
        "second-line-content": speach.row.visibility,
        class: "speachCell",
        "data-test": 'speach-edit-' + speach.$index
      }, {
        secondLine: _withCtx(() => [_createElementVNode("div", _hoisted_20, [speach.row.isPinnedOnHome ? (_openBlock(), _createBlock(_component_w_tool_tip, {
          key: 0,
          text: _ctx.$t('admin.dashboard.speaches.search.placeholder.pinnedOnHome')
        }, {
          default: _withCtx(() => [_createVNode(_component_icon, {
            icon: "pin-outline"
          })]),
          _: 1
        }, 8, ["text"])) : _createCommentVNode("", true), _createVNode(_component_w_tool_tip, {
          text: _ctx.$t('admin.dashboard.speaches.filterChip.visibility', {
            visibility: _ctx.visibilityTag(speach.row.visibility)
          })
        }, {
          default: _withCtx(() => [speach.row.visibility === _ctx.VisibilityEnum.PRIVE ? (_openBlock(), _createBlock(_component_icon, {
            key: 0,
            icon: "link-lock"
          })) : speach.row.visibility === _ctx.VisibilityEnum.SEMI_PRIVE ? (_openBlock(), _createBlock(_component_icon, {
            key: 1,
            icon: "link"
          })) : speach.row.visibility === _ctx.VisibilityEnum.RESTREINT ? (_openBlock(), _createBlock(_component_icon, {
            key: 2,
            icon: "lock-outline"
          })) : (_openBlock(), _createBlock(_component_icon, {
            key: 3,
            icon: "earth"
          }))]),
          _: 2
        }, 1032, ["text"]), speach.row.isWorkflowInProgress || speach.row.regulated_gmp && speach.row.wf_name ? (_openBlock(), _createBlock(_component_w_tag, {
          key: 1,
          class: "tableChip workflowChip",
          "with-tool-tip": false,
          ellipsis: true,
          "text-tag": speach.row.wf_name,
          round: "",
          closable: false
        }, null, 8, ["text-tag"])) : _createCommentVNode("", true)])]),
        _: 2
      }, 1032, ["speach", "search-term", "second-line-content", "data-test"])]),
      _: 1
    }), _createVNode(_component_el_table_column, null, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.author')), 1)]),
      default: _withCtx(speach => [_createVNode(_component_user_cell, {
        user: _ctx.getSpeachAuthor(speach.row),
        "search-term": _ctx.filterByAuthor,
        "second-line-content": _ctx.getSpeachAuthor(speach.row).email,
        class: "userCell"
      }, null, 8, ["user", "search-term", "second-line-content"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "150"
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.date')), 1)]),
      default: _withCtx(speach => [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('admin.dashboard.speaches.state.date.published')), 1)]), _createVNode(_component_w_date, {
        class: "tableCell",
        "string-date": speach.row.lastUpdatedDate
      }, null, 8, ["string-date"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "150"
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('admin.dashboard.speaches.periodicReview.filters.nextReviewDate.title')), 1)]),
      default: _withCtx(speach => [_createVNode(_component_w_date, {
        class: "tableCell",
        "string-date": speach.row.speachMetadata.nextPeriodicReview
      }, null, 8, ["string-date"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "150"
    }, {
      default: _withCtx(speach => [_createElementVNode("div", _hoisted_25, [speach.row.speachMetadata.periodicReviewUsers && speach.row.speachMetadata.periodicReviewUsers.length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "clickableCell",
        onClick: $event => _ctx.openReviewersManager(speach.row)
      }, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('admin.dashboard.speaches.periodicReview.manageReviewers.tooltip')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createVNode(_component_icon, {
          class: "clickableIcon clickableIconEnabled",
          icon: "account-multiple-outline"
        }), _createElementVNode("div", _hoisted_28, _toDisplayString(speach.row.speachMetadata.periodicReviewUsers.length), 1)])]),
        _: 2
      }, 1032, ["text"])], 8, _hoisted_26)) : _createCommentVNode("", true), speach.row.delayed_till ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('admin.dashboard.speaches.delayedTill') + ' ' + _ctx.$d(new Date(speach.row.delayedTillTimestamp))
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          class: "clickableIcon disabled",
          icon: "clock-outline"
        })]),
        _: 2
      }, 1032, ["text"])])) : _createCommentVNode("", true), speach.row.speachMetadata.periodicReviewOperation === _ctx.PeriodicReviewOperation.REVISION_NEEDED ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('admin.dashboard.speaches.periodicReview.filters.action.revisionNeeded')
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          class: "clickableIcon disabled",
          icon: "hammer-wrench"
        })]),
        _: 1
      }, 8, ["text"])])) : _createCommentVNode("", true), !speach.row.speachMetadata.periodicReviewUsers || speach.row.speachMetadata.periodicReviewUsers.length == 0 ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "clickableCell",
        onClick: $event => _ctx.openReviewersManager(speach.row)
      }, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('admin.dashboard.speaches.periodicReview.manageReviewers.tooltip')
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          class: "clickableIcon clickableIconEnabled",
          icon: "account-multiple-plus-outline"
        })]),
        _: 1
      }, 8, ["text"])], 8, _hoisted_31)) : _createCommentVNode("", true), speach.row.speachMetadata.periodicReviewOperation === _ctx.PeriodicReviewOperation.ARCHIVE ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "clickableCell",
        onClick: $event => _ctx.archiveSpeach(speach.row)
      }, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('admin.dashboard.speaches.multiselect.archive')
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          class: "clickableIcon clickableIconEnabled",
          icon: "delete-outline"
        })]),
        _: 1
      }, 8, ["text"])], 8, _hoisted_32)) : _createCommentVNode("", true)])]),
      _: 1
    }), _ctx.busyInfiniteLoading ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_loader)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["data"])) : _createCommentVNode("", true)], 2), _ctx.isLoaded ? (_openBlock(), _createBlock(_component_infinite_loading, {
    key: 0,
    identifier: _ctx.gridID,
    distance: 200,
    onInfinite: _ctx.debounceInfinite
  }, {
    "no-more": _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("div", null, null, -1)])),
    "no-results": _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("div", null, null, -1)])),
    spinner: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createVNode(_component_loader)])]),
    _: 1
  }, 8, ["identifier", "onInfinite"])) : _createCommentVNode("", true), _ctx.managePeriodicReviewers ? (_openBlock(), _createBlock(_component_w_dialog, {
    key: 1,
    visible: _ctx.managePeriodicReviewers,
    onOnDialogClose: _cache[7] || (_cache[7] = $event => _ctx.managePeriodicReviewers = false),
    title: _ctx.$t('admin.dashboard.speaches.batchEdit', {
      count: 1
    })
  }, {
    default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
      default: _withCtx(() => [_createVNode(_component_manage_periodic_reviewers, {
        "speach-to-update": _ctx.selectedSpeach,
        onReviewersSuccess: _ctx.updateReviewers,
        onReviewersCancel: _ctx.closeReviewersManager
      }, null, 8, ["speach-to-update", "onReviewersSuccess", "onReviewersCancel"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["visible", "title"])) : _createCommentVNode("", true)], 2);
}